// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Absolute Center Spinner */
.vv-loading-background {
    position: fixed;
    z-index: 2051;
    height: 2em;
    width: 2em;
    overflow: show;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
  
  /* Transparent Overlay */
  .vv-loading-background:before {
    content: '';
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* background-color: rgba(255, 255, 255, 0.542); */
    background-color: rgba(0, 0, 0, 0.118);
    /* background-color: rgba(46, 93, 196, 0.761); */
  }
  
  #vv-loader {
      /* border-top: 18px solid #22AADE;
      border-right: 18px solid rgba(255, 255, 255, 0.501);
      border-bottom: 18px solid #D02433;
      border-left: 18px solid rgba(255, 255, 255, 0.501); */

      border-top: 18px solid #22AADE;
      border-right: 18px solid #D02433;
      border-bottom: 18px solid rgba(255, 255, 255, 0.501);
      border-left: 18px solid rgba(255, 255, 255, 0.501);

      position: absolute;
      left: 50%;
      top: 50%;
      z-index: 1;
      margin: -75px 0 0 -75px;
      border-radius: 50%;
      width: 130px;
      height: 130px;
      animation: spin 1.5s linear infinite;
    }
    
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    
    /* Add animation to "page content" */
    .animate-bottom {
      position: relative;
      -webkit-animation-name: animatebottom;
      -webkit-animation-duration: 1s;
      animation-name: animatebottom;
      animation-duration: 1s
    }
    
    @keyframes animatebottom { 
      from{ bottom:-100px; opacity:0 } 
      to{ bottom:0; opacity:1 }
    }
    
    #myDiv {
      display: none;
      text-align: center;
    }
  
  
   `, "",{"version":3,"sources":["webpack://./src/app/shared/components/loading-page/loading-page.component.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;IACI,eAAe;IACf,aAAa;IACb,WAAW;IACX,UAAU;IACV,cAAc;IACd,YAAY;IACZ,MAAM;IACN,OAAO;IACP,SAAS;IACT,QAAQ;EACV;;EAEA,wBAAwB;EACxB;IACE,WAAW;IACX,cAAc;IACd,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,kDAAkD;IAClD,sCAAsC;IACtC,gDAAgD;EAClD;;EAEA;MACI;;;2DAGqD;;MAErD,8BAA8B;MAC9B,gCAAgC;MAChC,oDAAoD;MACpD,kDAAkD;;MAElD,kBAAkB;MAClB,SAAS;MACT,QAAQ;MACR,UAAU;MACV,uBAAuB;MACvB,kBAAkB;MAClB,YAAY;MACZ,aAAa;MAEb,oCAAoC;IACtC;;IAOA;MACE,KAAK,uBAAuB,EAAE;MAC9B,OAAO,yBAAyB,EAAE;IACpC;;IAEA,oCAAoC;IACpC;MACE,kBAAkB;MAClB,qCAAqC;MACrC,8BAA8B;MAC9B,6BAA6B;MAC7B;IACF;;IAOA;MACE,MAAM,aAAa,EAAE,UAAU;MAC/B,IAAI,QAAQ,EAAE,UAAU;IAC1B;;IAEA;MACE,aAAa;MACb,kBAAkB;IACpB","sourcesContent":["/* Absolute Center Spinner */\n.vv-loading-background {\n    position: fixed;\n    z-index: 2051;\n    height: 2em;\n    width: 2em;\n    overflow: show;\n    margin: auto;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n  }\n  \n  /* Transparent Overlay */\n  .vv-loading-background:before {\n    content: '';\n    display: block;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    /* background-color: rgba(255, 255, 255, 0.542); */\n    background-color: rgba(0, 0, 0, 0.118);\n    /* background-color: rgba(46, 93, 196, 0.761); */\n  }\n  \n  #vv-loader {\n      /* border-top: 18px solid #22AADE;\n      border-right: 18px solid rgba(255, 255, 255, 0.501);\n      border-bottom: 18px solid #D02433;\n      border-left: 18px solid rgba(255, 255, 255, 0.501); */\n\n      border-top: 18px solid #22AADE;\n      border-right: 18px solid #D02433;\n      border-bottom: 18px solid rgba(255, 255, 255, 0.501);\n      border-left: 18px solid rgba(255, 255, 255, 0.501);\n\n      position: absolute;\n      left: 50%;\n      top: 50%;\n      z-index: 1;\n      margin: -75px 0 0 -75px;\n      border-radius: 50%;\n      width: 130px;\n      height: 130px;\n      -webkit-animation: spin 1.5s linear infinite;\n      animation: spin 1.5s linear infinite;\n    }\n    \n    @-webkit-keyframes spin {\n      0% { -webkit-transform: rotate(0deg); }\n      100% { -webkit-transform: rotate(360deg); }\n    }\n    \n    @keyframes spin {\n      0% { transform: rotate(0deg); }\n      100% { transform: rotate(360deg); }\n    }\n    \n    /* Add animation to \"page content\" */\n    .animate-bottom {\n      position: relative;\n      -webkit-animation-name: animatebottom;\n      -webkit-animation-duration: 1s;\n      animation-name: animatebottom;\n      animation-duration: 1s\n    }\n    \n    @-webkit-keyframes animatebottom {\n      from { bottom:-100px; opacity:0 } \n      to { bottom:0px; opacity:1 }\n    }\n    \n    @keyframes animatebottom { \n      from{ bottom:-100px; opacity:0 } \n      to{ bottom:0; opacity:1 }\n    }\n    \n    #myDiv {\n      display: none;\n      text-align: center;\n    }\n  \n  \n   "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
